const IsFieldValid = field => (field.$error ? false : null)
const RequiredMessage = name => `${name} is required.`
const MaxLengthMessage = (name, length) =>
  `${name} must be ${length} characters or fewer.`
const RequiredAndMaxLengthMessage = (name, field) =>
  !field.required
    ? RequiredMessage(name)
    : MaxLengthMessage(name, field.$params.maxLength.max)
const RequiredAndAlphaAndMaxLengthMessage = (name, field) =>
  !field.required
    ? RequiredMessage(name)
    : !field.alpha
    ? `${name} must be alphabetic.`
    : MaxLengthMessage(name, field.$params.maxLength.max)
const RequiredAndNumericAndMaxLengthMessage = (name, field) =>
  !field.required
    ? RequiredMessage(name)
    : !field.numeric
    ? `${name} must be numeric.`
    : MaxLengthMessage(name, field.$params.maxLength.max)
const MaxLengthAndAlphaMessage = (name, field) =>
  !field.alpha
    ? `${name} must be alphabetic.`
    : MaxLengthMessage(name, field.$params.maxLength.max)
const MaxLengthAndAlphaNumMessage = (name, field) =>
  !field.alphaNum
    ? `${name} must be alphanumeric.`
    : MaxLengthMessage(name, field.$params.maxLength.max)
const MaxLengthAndNumericMessage = (name, field) =>
  !field.numeric
    ? `${name} must be numeric.`
    : MaxLengthMessage(name, field.$params.maxLength.max)
const PhoneMessage = () => 'Phone number is invalid.'
const RequiredAndPhoneMessage = field =>
  !field.required ? RequiredMessage('Phone number') : PhoneMessage()
const EmailMessage = (name, field) =>
  !field.required
    ? RequiredMessage(name)
    : !field.email
    ? `${name} must be a valid email.`
    : MaxLengthMessage(name, field.$params.maxLength.max)
const PasswordMessage = (name, field) => {
  // Vuelidate's field.$model is the current value
  const value = field.$model || ''
  if (!field.required) {
    return RequiredMessage(name)
  }
  if (field.$dirty && !field.required) {
    return RequiredMessage(name)
  }
  const allowedCharRegex = /^[A-Za-z\d!@#$%^&*?]+$/
   const pwdMessage1 =
    `must be ${field.$params.minLength.min} to ${field.$params.maxLength.max} characters long` +
    `, contain at least one lowercase letter (a-z)` +
    `, at least one uppercase letter (A-Z)` +
    `, at least one digit (0-9)` +
    `, at least one special character (!, @, #, $, %, ^, &, *, ?)`
  const pwdMessage2 = `contains illegal character(s) - only letters, digits, and special characters !, @, #, $, %, ^, &, *, ? are allowed`
  let msg =
    !field.minLength ||
    !field.maxLength ||
    !/[a-z]/.test(value) ||
    !/[A-Z]/.test(value) ||
    !/\d/.test(value) ||
    !/[!@#$%^&*?]/.test(value)
      ? pwdMessage1
      : (!allowedCharRegex.test(value) ? pwdMessage2 : '')
  if (msg.length > 0) {
    msg = `${name} ${msg}.`
  }
  // All checks passed
  return msg
}
const FileMessage = field =>
  !field.required
    ? RequiredMessage('File')
    : 'Allowed file types: .pdf, .txt, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg'

export default {
  IsFieldValid,
  RequiredMessage,
  MaxLengthMessage,
  RequiredAndMaxLengthMessage,
  RequiredAndAlphaAndMaxLengthMessage,
  RequiredAndNumericAndMaxLengthMessage,
  MaxLengthAndAlphaMessage,
  MaxLengthAndAlphaNumMessage,
  MaxLengthAndNumericMessage,
  PhoneMessage,
  RequiredAndPhoneMessage,
  EmailMessage,
  PasswordMessage,
  FileMessage
}
